/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Forward_One_SecondInputs */

const en_shortcut_keys_name_forward_one_second = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward 1 Second`)
};

const fr_shortcut_keys_name_forward_one_second = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avancer d'une seconde`)
};

const de_shortcut_keys_name_forward_one_second = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Sekunde vorwärts`)
};

const it_shortcut_keys_name_forward_one_second = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanti di 1 secondo`)
};

const ru_shortcut_keys_name_forward_one_second = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перемотать на 1 секунду вперед`)
};

const es_shortcut_keys_name_forward_one_second = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzar 1 segundo`)
};

const zh_cn2_shortcut_keys_name_forward_one_second = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前进 1 秒`)
};

const ja_shortcut_keys_name_forward_one_second = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1秒進む`)
};

const hi_shortcut_keys_name_forward_one_second = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 सेकंड आगे`)
};

const pt_pt2_shortcut_keys_name_forward_one_second = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_SecondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avançar 1 segundo`)
};

/**
* | output |
* | --- |
* | "Forward 1 Second" |
*
* @param {Shortcut_Keys_Name_Forward_One_SecondInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_forward_one_second = /** @type {((inputs?: Shortcut_Keys_Name_Forward_One_SecondInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Forward_One_SecondInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_forward_one_second(inputs)
	if (locale === "de") return de_shortcut_keys_name_forward_one_second(inputs)
	if (locale === "it") return it_shortcut_keys_name_forward_one_second(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_forward_one_second(inputs)
	if (locale === "es") return es_shortcut_keys_name_forward_one_second(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_forward_one_second(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_forward_one_second(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_forward_one_second(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_forward_one_second(inputs)
	return en_shortcut_keys_name_forward_one_second(inputs)
});